<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import ProductService from '@/services/product';
import { VMoney } from 'v-money'

export default {
  page: {
    title: "Adicionais de Produtos",
  },
  components: { Layout, PageHeader },
  directives: { money: VMoney },
  data() {
    return {
      title: "Adicionais de Produtos",
      products: [],
      searchValue: '',
      complement: {},
      modalError: '',
      productToRemove: '',

      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false,
      },
    }
  },
  computed: {
    rows() {
      return this.products.length;
    }
  },
  mounted() {
    this.load(1);
  },
  methods: {
    load(page, loader) {
      if (!loader) {
        loader = this.$loading.show();
      }

      ProductService.getComplements(page, this.searchValue).then(res => {
        loader.hide();

        this.products = res.data.data;

        this.count = res.data.count;
        this.currentCount = res.data.currentCount;
        this.currentPage = res.data.currentPage;
        this.totalPages = res.data.totalPages;
        this.perPage = res.data.perPage;
        this.startIndex = res.data.startIndex;
        this.endIndex = res.data.endIndex;
      }).catch(() => {
        loader.hide();
      })
    },
    inactiveProduct(product) {
      let loader = this.$loading.show();

      const data = {
        _id: product._id,
        active: false,
      }

      ProductService.saveProduct(data).then(() => {
        loader.hide();
        product.active = false;

        this.$toast.open('Adicional inativado')
      }).catch((err) => {
        this.$toast.error(err);
        loader.hide();
      })
    },
    activeProduct(product) {
      let loader = this.$loading.show();

      const data = {
        _id: product._id,
        active: true,
      }

      ProductService.saveProduct(data).then(() => {
        loader.hide();
        product.active = true;

        this.$toast.open('Adicional ativado')
      }).catch((err) => {
        this.$toast.error(err);
        loader.hide();
      })
    },
    newComplement() {
      this.complement = {}
      this.modalError = '';

      this.$bvModal.show('modal-edit');
    },
    async saveComplement() {
      this.modalError = '';
      if (!this.complement.description) {
        return this.modalError = 'Informe uma descrição para o produto adicional';
      }

      let loader = this.$loading.show();

      try {
        if (this.complement._id) {
          await ProductService.updateComplement(this.complement);
        } else {
          await ProductService.createComplement(this.complement);
        }

        this.$bvModal.hide('modal-edit');
        this.$toast.open('Dados atualizados com sucesso');

        this.load(1, loader);
      } catch (err) {
        loader.hide();

        const errorData = err.response.data;
        if (errorData.code) {
          if (errorData.code === 'E9999') {
            return this.modalError = errorData.msg;
          }
        }

        this.modalError = 'Ocorreu um erro ao salvar o adicional';
      }
    },
    editComplement(item) {
      this.complement = {
        _id: item._id,
        description: item.description,
        details: item.details,
        price: item.price.toFixed(2).replace('.', ','),
      }
      this.modalError = '';

      this.$bvModal.show('modal-edit');
    },
    removeComplement() {
      this.$bvModal.hide('modal-remove');      

      let loader = this.$loading.show();

      ProductService.removeComplement(this.productToRemove._id).then(() => {
        this.load(1, loader);
        this.$toast.open('Produto excluído');
      }).catch(() => {
        loader.hide();
        this.$toast.error('Ocorreu um erro ao excluir o registro');
      })
    },
    onPageChange() {
      this.load(this.currentPage);
    },
    search() {
      this.load(1);
    },
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-6">
                <div class="position-relative search-input search-box">
                  <form @submit.prevent="search" class="align-items-center">
                    <input
                      type="text"
                      class="form-control"
                      v-model="searchValue"
                      placeholder="Procurar por descrição..."
                    />

                    <button type="submit" class="btn btn-rounded btn-outline-primary ml-2">
                      Pesquisar
                    </button>
                  </form>
                </div>
              </div>
              <div class="col-6">
                <div class="text-right">
                  <button type="button" class="btn btn-primary btn-rounded mb-2 mr-2" @click="newComplement">
                    <i class="mdi mdi-plus mr-1"></i> Novo Adicional
                  </button>
                </div>
              </div>
              <!-- end col-->
            </div>
            <!-- Table data -->
            <!-- <Product :products="products" :loadProducts="this.load" /> -->
            <div class="table-responsive mb-0">
              <table class="table table-centered">
                <thead class="thead-light">
                  <tr>
                    <th>Descrição</th>
                    <th>Status</th>
                    <th>Preço</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="data in products" :key="data._id">
                    <td>
                      {{data.description}}
                      <span v-if="data.kind !== 'complement'" class="badge badge-pill badge-soft-primary font-size-10">Produto</span>
                    </td>
                    <td>
                      <span
                        class="badge badge-pill badge-soft-primary font-size-12"
                        :class=" {
                          'badge-soft-primary': data.active === true,
                          'badge-soft-secondary': data.active === false,
                        }"
                      >{{data.active ? 'Ativo' : 'Inativo'}}</span>
                    </td>
                    <td>
                      <p class="text-muted mb-0 font-size-10" v-if="data.price_from">de {{data.price_from | currency}}</p>
                      {{data.price | currency}}
                    </td>
                    <td>
                      <b-dropdown class="card-drop" variant="white" right toggle-class="p-0">
                        <template v-slot:button-content>
                          <i class="mdi mdi-dots-horizontal font-size-18"></i>
                        </template>

                        <b-dropdown-item v-if="data.kind === 'complement'" @click="editComplement(data)">
                          <i class="fas fa-pencil-alt text-success mr-2 mt-2"></i> Editar
                        </b-dropdown-item>

                        <b-dropdown-item v-if="data.active" @click="inactiveProduct(data)">
                          <i class="fas fa-pause text-warning mr-2 mt-2"></i> Inativar
                        </b-dropdown-item>

                        <b-dropdown-item v-if="!data.active" @click="activeProduct(data)">
                          <i class="fas fa-play text-success mr-2 mt-2"></i> Ativar
                        </b-dropdown-item>

                        <b-dropdown-divider v-if="data.kind === 'complement'"></b-dropdown-divider>
                        
                        <b-dropdown-item v-if="data.kind === 'complement'" v-b-modal.modal-remove @click="productToRemove = data">
                          <i class="fas fa-trash-alt text-danger mr-2 mt-2"></i> Excluir
                        </b-dropdown-item>    
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>  
            
            <div class="row justify-content-md-between align-items-md-center mt-4">
              <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{count}}</div>

              <div class="col-xl-5">
                <div class="text-md-right float-xl-right mt-2 pagination-rounded">
                  <b-pagination
                    v-model="currentPage" 
                    :total-rows="count"
                    :per-page="perPage"
                    @input="onPageChange"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <b-modal id="modal-edit" :title="complement._id ? 'Alterando Adicional' : 'Novo Adicional'" centered>
      <b-alert v-if="modalError" v-model="modalError" variant="danger" class="mt-3" dismissible>{{modalError}}</b-alert>

      <div class="row">
        <div class="col-8">
          <div class="form-group">
            <label for="description">Descrição</label>
            <input id="description" name="description" type="text" class="form-control" v-model="complement.description" />
          </div>
        </div>

        <div class="col-4">
          <div class="form-group">
            <label for="price">Preço (R$)</label>
            <input
              id="price"
              name="price"
              type="tel"
              class="form-control"
              v-model="complement.price"
              v-money="money"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <label for="price">Detalhes (opcional)</label>
          <textarea id="details" class="form-control" rows="4" v-model="complement.details" placeholder="Informe aqui o detalhe do produto adicional"></textarea>
        </div>
      </div>
      
      <template v-slot:modal-footer>
        <b-button variant="link" @click="$bvModal.hide('modal-edit')">Cancelar</b-button>
        <b-button variant="primary" @click="saveComplement()">
          Salvar
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-remove"
      title="Excluir Adicional?"
      title-class="font-18"
      centered
    >
      <p>Confirma a exclusão do produto adicional?</p>

      <div slot="modal-footer">
        <b-btn variant="link" @click="$bvModal.hide('modal-remove')" class="mr-3">Cancelar</b-btn>
        <b-btn variant="primary" @click="removeComplement">Excluir</b-btn>
      </div>
    </b-modal>
  </Layout>
</template>

<style lang="scss">
  .search-box form {
    display: flex;
    flex-direction: row;
  }

  .search-box .form-control {
    padding-left: 20px;
  }

  .input-search {
    width: 90%;
  }
</style>